export default {
  missions: 'missions',
  tasks: 'tasks',
  rewards: 'rewards'
};
